import { createRoute } from '@tanstack/react-router'

import ContactCreate from '../pages/ContactCreate/ContactCreate'
import { contactRoute } from './ContactRoute'

export const contactCreateRoute = createRoute({
  getParentRoute: () => contactRoute,
  component: () => <ContactCreate />,
  path: '/create'
})
